"use strict";

var userOwns = {
  methods: {
    userOwns: function userOwns(thing) {
      if (typeof thing === "undefined") {
        return true;
      }

      return globals.user.id === thing.creator_id || Fn.isAdmin();
    }
  }
};

module.exports = userOwns;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/UserOwns.js
// module id = 4Th2
// module chunks = 0 1